'use client';

import './search-results.scss';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchBar } from '../../molecules/search-bar/search-bar';
import {
  usePaginationQueryParams,
  useSearchQueryParams,
} from '../../utils/query-params';
import { getLegacyQuery } from '../../utils/search';
import { SearchResultsList } from './search-results-list';

export const SearchResults = () => {
  const { t } = useTranslation();
  const { searchFilters, setSearchFilters } = useSearchQueryParams();
  const { currentPage, setCurrentPage } = usePaginationQueryParams();
  const itemsPerPage = 10;

  const handlePageChange = (p: number) => {
    setCurrentPage(p);
  };

  const handleQueryChange = (q: string) => {
    setSearchFilters((prev) => ({ ...prev, q, page: 0 }));
  };

  // The legacy search uses a fragment like #stq=kenya.
  // That page will be redirected here, so if the query exists, let's use it.
  useEffect(() => {
    const legacyQuery = getLegacyQuery();
    if (legacyQuery) {
      handleQueryChange(legacyQuery);
    }
  }, []);

  return (
    <section className="SearchResults component">
      <div className="SearchResults__container container">
        <SearchBar
          title={t('skippy.siteSearch.searchResults')}
          titleSize="lg"
          placeholder={t('skippy.siteSearch.searchOurSite')}
          onQueryChange={(value) => handleQueryChange(value)}
          defaultQuery={searchFilters.q}
          enableQuickSearch
        />
        <SearchResultsList
          queryText={searchFilters.q}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => handlePageChange(page)}
        />
      </div>
    </section>
  );
};
